import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=1406d393&scoped=true&"
import script from "./FaqComponent.vue?vue&type=script&lang=ts&"
export * from "./FaqComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FaqComponent.vue?vue&type=style&index=0&id=1406d393&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406d393",
  null
  
)

export default component.exports